module.exports = '<svg width="28" height="32" viewBox="0 0 28 32"><path d="M26.02 0h-20C2.7 0 0 2.68 0 6v20c0 3.32 2.7 6 6.02 6h20c1.106 0 1.98-.894 1.98-2V2c0-1.106-.876-2-1.98-2zM22 9a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v2zm0 6a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v2zm2 13H6.02c-1.1 0-2-.9-2-2s.9-2 2-2H24v4z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/book-6.js
// module id = 1019
// module chunks = 14